import { blobToExcel } from '@/utils/blobToExcel';
import { request } from 'ice';
import { stringify } from 'query-string';

// 入库单下发
async function putaWayNotify(form) {
  const res = await request.post('/service/iot/putawayNotify', {
    ...form,
  });

  return {
    res,
  };
}

// 商品信息同步
async function getSkuInfoNotify(form) {
  const res = await request.post('/service/iot/skuInfoNotify', {
    ...form,
  });

  return {
    res,
  };
}

// 出库单下发
async function outPickNotify(form) {
  const res = await request.post('/service/iot/pickNotify', {
    ...form,
  });

  return {
    res,
  };
}

export { getSkuInfoNotify, putaWayNotify, outPickNotify };
